import React from 'react';
import PropTypes from 'prop-types';
import { Route } from "react-router-dom";
import UiUtils from '../../utils/UiUtils';
import SearchBar from '../../components/search-bar/SearchBar';
import EmpresasBusqueda from './components/empresas-busqueda/EmpresasBusqueda';
import EmpresasDetalle from './components/empresas-detalle/EmpresasDetalle';
import { EMPRESAS_SEARCH_OPTIONS } from '../../config';

class Empresas extends React.Component {

    onBusquedaHandler = (tipo, valor) => {
        UiUtils.navigateTo(`${this.props.match.url}/busqueda/${tipo}/${valor}`);
    }

    onResultadoSeleccionado = (valor, isPerson) => {
        UiUtils.navigateTo(`/dashboard/${isPerson ? 'personas' : 'empresas'}/detalle/${valor}`);
    }

    render() {
        return (
            <div>
                <SearchBar opciones={EMPRESAS_SEARCH_OPTIONS} onBusqueda={this.onBusquedaHandler} />
                <Route path={`${this.props.match.url}/busqueda/:tipo/:valor`} render={({ match }) => (
                    <EmpresasBusqueda tipo={match.params.tipo} valor={match.params.valor}
                        onResultadoSeleccionado={this.onResultadoSeleccionado} />
                )} />
                <Route path={`${this.props.match.url}/detalle/:cuit`} render={({match}) => (
                    <EmpresasDetalle cuit={match.params.cuit} />
                )} />
            </div>
        );
    }
}

Empresas.propTypes = {
    match: PropTypes.object
};

export default Empresas;



// WEBPACK FOOTER //
// ./src/scenes/empresas/Empresas.js